<div class='container-align-center margin-top'>
    <logo></logo>
</div>
<div class='container-align-center'>
    <mat-card>
        <mat-card-title>Login</mat-card-title>
        <p>Please enter credentials to login</p>
        <mat-card-content>
            <form>
            <mat-form-field appearance="fill">
                <mat-label>Email</mat-label>
                <input type="email" matInput [formControl]="emailFormControl" placeholder="Ex. pat@example.com" [(ngModel)]="credentials.email" name="email">
                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">Please enter a valid email address</mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">Email is <strong>required</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Password</mat-label>
                <input [type]="showPassword ? 'text' : 'password'" matInput [formControl]="passwordFormControl" placeholder="Password" [(ngModel)]="credentials.password" name="password">
                <mat-icon matSuffix class="button-cursor" [title]="showPassword ? 'Hide password' : 'Show password'" (click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                <mat-error *ngIf="passwordFormControl.hasError('required')">Password is <strong>required</strong></mat-error>
            </mat-form-field>
            <a [routerLink]="['/reset']" class='form-links'>Forgot password?</a>
            </form>
        </mat-card-content>
        <mat-card-actions>
            <button mat-flat-button color="primary" [disabled]="!formValid()" (click)="login()">Login</button>
            <button mat-stroked-button (click)="cancel()">Cancel</button>
        </mat-card-actions>
    </mat-card>
  </div>